export const environment = {
    production: false,
    apiUrl: "https://white-hat-bots-dashboard-api-test-djcwa3fmf9f9febm.eastus2-01.azurewebsites.net",
    appUrl: "https://app-test.whitehatbots.com",
    adminUrl: "https://dashboard-test.whitehatbots.com",
};
